



































import Vue, { PropType } from 'vue'
import { deleteMultipleTariffs } from '~/api/Remittances/remittances.api'
import CreateDialog from '~/components/CreateDialog.vue'
import TextButton from '~/components/TextButton.vue'
import { TableHeader } from '~/utils/interfaces'
import { Tariff } from '~/utils/interfaces/remittance.interface'

export default Vue.extend({
  components: {
    CreateDialog,
    TextButton,
  },
  props: {
    selectedTariffs: {
      type: Array as PropType<Tariff[]>,
      default: () => [] as Tariff[],
    },
  },
  data() {
    return {
      model: false,
      loading: false,
      currentTariffs: [] as Tariff[],
      headers: [
        {
          text: this.$t('name'),
          value: 'name',
        },
        {
          text: this.$t('interval') + ' ($)',
          value: 'interval',
        },
        {
          text: this.$t('minimum-commission') + ' ($)',
          value: 'min_commission',
        },
        {
          text: this.$t('percent-commission') + ' (%)',
          value: 'percent_commission',
        },
        {
          text: this.$t('delivery_currency'),
          value: 'delivery_currency',
        },
        {
          text: this.$t('exchange_rate'),
          value: 'exchange_rate',
        },
        {
          text: this.$t('province'),
          value: 'region_name',
        },
      ] as TableHeader<Tariff>[],
    }
  },
  methods: {
    async onSuccess() {
      this.loading = true
      try {
        await deleteMultipleTariffs(
          this.currentTariffs.map(tariff => tariff.uuid),
        )
        this.model = false
      } finally {
        this.loading = false
      }
    },
  },
  watch: {
    model(v: boolean) {
      if (v) {
        this.currentTariffs = [...this.selectedTariffs]
      }
    },
  },
})
